var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapActions, mapGetters } from "vuex";
import GlobalVue from '../../globalVue';
import { Loading } from 'element-ui';
import ShoppingManageService from '../../api/ShoppingManageService';
import { EColumnType } from '../../enum/EColumnType';
import { EShopLinkType } from '../../enum/EShopLinkType';
import { copy } from '../../helper/clipboard';
import Subassembly from './components/decoration/Subassembly';
import Preview from './components/decoration/Preview';
import ImgUploaderList from './components/decoration/ImgUploaderList';
import AddGoods from './components/decoration/addGoodsCol2/AddGoods';
import GoodCategory from '../goodcategory/GoodCategory.vue';
var componentMap = {
    1: 'recommend-item',
    2: 'recommend-item',
    3: 'recommend-item',
    4: 'carousel-item',
    5: 'category-item',
    6: 'quick-link-item',
    7: 'quick-link-item',
};
var defaultPicMap = {
    '6': 'https://cgptdoc.acescm.cn/shopping/frequent_goods.png',
    '7': 'https://cgptdoc.acescm.cn/shopping/order_again.png'
};
var ConfigDetail = (function (_super) {
    __extends(ConfigDetail, _super);
    function ConfigDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pageHeight = 0;
        _this.EColumnType = EColumnType;
        _this.eShopLinkType = EShopLinkType;
        _this.configItemType = '';
        _this.initConfigItemData = {
            data: {
                images: []
            }
        };
        _this.configItemData = _this.initConfigItemData;
        _this.selectedGoods = [];
        _this.isRefreshCom = false;
        _this.lastCurrentIndex = -1;
        _this.formData = [];
        _this.previewData = JSON.parse(JSON.stringify(_this.formData));
        _this.clipboardCopy = copy;
        return _this;
    }
    ConfigDetail.prototype.created = function () {
        this.service = ShoppingManageService.getInstance();
    };
    ConfigDetail.prototype.mounted = function () {
        var _this = this;
        this.getDetail();
        setTimeout(function () {
            _this.pageHeight = document.documentElement.clientHeight - 182;
        }, 300);
    };
    ConfigDetail.prototype.deletePreviewItem = function (item) {
        if (item.current) {
            this.configItemType = '';
        }
    };
    ConfigDetail.prototype.configPreviewItem = function (item, allConfig) {
        this.configItemType = '';
        var configItem = item || this.initConfigItemData;
        this.configItemType = configItem.type;
        this.configItemData = configItem;
        this.isRefreshCom = !this.isRefreshCom;
        if (this.configItemType == 3) {
            var goodsImages = JSON.parse(JSON.stringify(configItem.data.images));
            goodsImages = goodsImages.filter(function (v) { return v.relate_id; }).map(function (v) {
                return v.goods;
            });
            this.selectedGoods = goodsImages;
        }
    };
    ConfigDetail.prototype.closeConfig = function () {
        this.previewData = this.previewData.map(function (v) {
            v.current = false;
            return v;
        });
        this.configItemType = '';
    };
    ConfigDetail.prototype.dragConfig = function (configList) {
        this.previewData = configList;
    };
    ConfigDetail.prototype.previewImmediate = function (goodsList) {
        var goodsListFormat = goodsList.map(function (v) {
            var item = {};
            var image = '';
            item.goods = v;
            item.relate_id = v.goods_id;
            var isHasSelected = false;
            v.main_pic.map(function (i) {
                if (i.selected) {
                    image = i.url;
                    isHasSelected = true;
                    return;
                }
            });
            if (!isHasSelected) {
                image = (Array.isArray(v.main_pic) && v.main_pic.length > 0) ? v.main_pic[0].url : '';
            }
            item.image = image;
            item.url = image;
            return item;
        });
        this.configItemData.data.images = goodsListFormat;
    };
    ConfigDetail.prototype.tidyGetImageRelateId = function (item) {
        if (item.type == this.eShopLinkType.CATEGORY) {
            item.relate_id_category = item.relate_id;
            item.relate_name_category = item.relate_name;
            item.relate_id_good = '';
            item.relate_name_good = '';
        }
        else {
            item.relate_id_good = item.relate_id;
            item.relate_name_good = item.relate_name;
            item.relate_id_category = '';
            item.relate_name_category = '';
        }
    };
    ConfigDetail.prototype.initDataFormat = function (newVal) {
        var valConfig = Array.isArray(newVal) ? newVal : [];
        var valConfigFormat = (valConfig || []).map(function (i) {
            var item = {};
            item.type = i.type;
            item.typeName = componentMap[i.type];
            item.class = 'preview-target';
            item.data = __assign({}, i, { images: Array.isArray(i.images) ? i.images.map(function (j) {
                    j.url = j.image;
                    return j;
                }) : [] });
            if (item.type == 6 || item.type == 7) {
                item.data.button_text = (i.images[0] && i.images[0].button_text) || '';
            }
            return item;
        });
        var initConfig = valConfigFormat.length === 0 ? [
            {
                front_id: 'no-data-id',
                type: 'no-data',
                typeName: 'no-data',
                class: 'preview-target',
            },
        ] : [];
        var mergeConfig = initConfig.concat(valConfigFormat);
        var front_id = 1;
        mergeConfig.map(function (v) {
            v.front_id = front_id;
            front_id++;
            return v;
        });
        return mergeConfig;
    };
    ConfigDetail.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.decorationShow({}).then(function (res) {
            var data = res.data.data;
            _this.formData = _this.initDataFormat(data);
            _this.previewData = _this.formData;
            var previewRef = _this.$refs.preview;
            if (_this.lastCurrentIndex >= 0) {
                previewRef.showConfig(_this.previewData[_this.lastCurrentIndex]);
            }
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    ConfigDetail.prototype.saveDataFormat = function (configList) {
        var config = JSON.parse(JSON.stringify(configList));
        var configParams = config.map(function (v) {
            var item = {};
            item.type = v.type;
            item.field_name = (v.data && v.data.field_name) || '';
            item.is_show = (v.is_show !== null && v.is_show !== undefined) ? v.is_show : 1;
            item.images = (v.data && v.data.images) || [];
            item.images = item.images.map(function (i) {
                var ids = [];
                var relateIds = i.relate_id || '';
                var relateIdsLocal = i.relate_id_good || '';
                if (relateIdsLocal) {
                    ids = relateIdsLocal;
                }
                else {
                    ids = relateIds;
                }
                i.relate_id = ids;
                return {
                    image: i.url,
                    relate_id: i.relate_id,
                    relate_name: i.relate_name,
                    type: i.type || 2,
                };
            });
            if (item.type == 6 || item.type == 7) {
                var imageItem = {};
                imageItem.image = (item.images[0] && item.images[0].image) || defaultPicMap[item.type];
                imageItem.button_text = v.data.button_text || '';
                imageItem.type = 2;
                item.images[0] = imageItem;
            }
            return item;
        });
        configParams = configParams.filter(function (v) {
            return v.type !== 'no-data';
        });
        return configParams;
    };
    ConfigDetail.prototype.checkSave = function (configList) {
        var config = JSON.parse(JSON.stringify(configList));
        if (config.length === 0) {
            this.$message.warning('请至少配置一个组件');
            return false;
        }
        var errorType = 0;
        config.map(function (v) {
            if (v.type == 1 || v.type == 2 || v.type == 3) {
                if (!v.field_name) {
                    errorType = 1;
                }
            }
            var images = Array.isArray(v.images) ? v.images : [];
            if (v.type == 1 || v.type == 2 || v.type == 3 || v.type == 4) {
                images.map(function (i) {
                    if (!i.image && v.type != 3) {
                        errorType = 2;
                        return;
                    }
                    else if (i.image) {
                        var imageType = i.image.split('/')[1];
                        if (imageType === 'static') {
                            errorType = 3;
                            return;
                        }
                    }
                    if (!i.relate_id && (v.type == 3)) {
                        errorType = 5;
                        return;
                    }
                });
                if (images.length === 0 && (v.type == 1 || v.type == 2)) {
                    errorType = 4;
                    return;
                }
                if ((images || []).length === 0 && (v.type == 3)) {
                    errorType = 5;
                    return;
                }
            }
            if ((v.type == 6 || v.type == 7) && !(images[0] && images[0].button_text)) {
                console.log(images[0]);
                errorType = 6;
                return;
            }
        });
        if (errorType == 1) {
            this.$message.warning('栏目名称不能为空');
            return false;
        }
        if (errorType == 2) {
            this.$message.warning('您配置的组件图片上传不完全，请检查配置，如添加了组件项目，请一定要上传图片，否则删除该配置');
            return false;
        }
        if (errorType == 3) {
            this.$message.warning('组件图片不可使用默认的配置图片，请您自行上传图片或选择货品');
            return false;
        }
        if (errorType == 4) {
            this.$message.warning('请至少上传一张推广图片');
            return false;
        }
        if (errorType == 5) {
            this.$message.warning('请选择至少一个推荐货品，且不可用组件默认展示的推荐货品');
            return false;
        }
        if (errorType == 6) {
            this.$message.warning('请输入按钮文字');
            return false;
        }
        return true;
    };
    ConfigDetail.prototype.tidySetImageRelateId = function (item) {
        if (item.relate_id_good) {
            item.type = this.eShopLinkType.GOOD;
            item.relate_id = item.relate_id_good;
        }
        else {
            item.type = this.eShopLinkType.CATEGORY;
            item.relate_id = item.relate_id_category;
        }
    };
    ConfigDetail.prototype.save = function () {
        var _this = this;
        var lastCurrentIndex = -1;
        this.previewData.map(function (v, i) {
            if (v.current) {
                lastCurrentIndex = i;
            }
        });
        this.lastCurrentIndex = lastCurrentIndex;
        var configAllDataFormat = this.saveDataFormat(this.previewData);
        if (!this.checkSave(configAllDataFormat)) {
            return;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.decorationSave({ data: configAllDataFormat }).then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg);
            _this.getDetail();
            window._czc.push(["_trackEvent", '店铺装修', '保存', '保存']);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    ConfigDetail.prototype.goSetCategory = function () {
        this.getAuth('8002').then(function (pageAuth) {
            GlobalVue.$emit('addTab', {
                component: GoodCategory,
                title: '货品类别',
                name: 'good-category',
                showExist: true,
                cprops: {
                    Root_PageAuth: pageAuth && pageAuth.Auth,
                    root_PageAuth$$: pageAuth && pageAuth.Auth
                }
            });
        });
    };
    __decorate([
        Prop({
            required: true,
            type: Object
        })
    ], ConfigDetail.prototype, "shoppingDetail", void 0);
    ConfigDetail = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
            components: {
                Subassembly: Subassembly,
                Preview: Preview,
                ImgUploaderList: ImgUploaderList,
                AddGoods: AddGoods
            },
            methods: __assign({}, mapActions(["getAuth"])),
        })
    ], ConfigDetail);
    return ConfigDetail;
}(Vue));
export default ConfigDetail;
